import type {
  ApiFetchFaqPort,
  FaqCategory,
} from '~/handlers/ports/api-fetch-faq.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { sanitizeFaqAnswer } from '~/utils/apostatudo/sanitize-faq-answer';

export class ApostatudoApiFetchFaqAdapter implements ApiFetchFaqPort {
  async handle(): Promise<FaqCategory[]> {
    const response = await fetch(`${getApostatudoApiUrl()}/faq`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.warn(
        `[ApiFetchFaq] API returned ${response.status}: ${response.statusText}`,
      );

      return [];
    }

    const json = await response.json();
    const data = json?.data;

    if (!Array.isArray(data)) {
      console.warn('[ApiFetchFaq] API response is not an array:', json);

      return [];
    }

    return data.map(
      (cat: {
        id: string;
        name: string;
        questions: { id: string; question: string; answer: string }[];
      }) => ({
        id: cat.id,
        name: cat.name,
        items: (cat.questions ?? []).map((q) => ({
          id: q.id,
          question: q.question,
          answer: sanitizeFaqAnswer(q.answer),
        })),
      }),
    );
  }
}
